import {useState} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'

import Aside from '../Aside'
import ModernDrawer from '../Drawer'
import Style from './style'

import hamberger from 'shared/assets/hamberger.svg'
import logo from 'shared/assets/logo.png'
import scan from 'shared/assets/scan-file.svg'
import {
	convertRoleAsName,
	ROLE_FRANCHISE_MANAGER,
	ROLE_STORE_MANAGER,
} from 'shared/constant/lookup/role'
import useNameCookie from 'shared/model/useNameCookie'
import useRoleCookie from 'shared/model/useRoleCookie'

const Header = ({ versionData }) => {
	const location = useLocation()
	const path = location.pathname.split('/')
	const target = path[path.length - 1]
	const [isDrawerOpen, setIsDrawerOpen] = useState(false)
	const navigate = useNavigate()

	const [roleCookie] = useRoleCookie()
	const [nameCookie] = useNameCookie()

	const toggleDrawer = () => {
		setIsDrawerOpen(!isDrawerOpen)
	}

	const closeDrawer = () => {
		setIsDrawerOpen(false)
	}
	return (
		<>
			<Style.Header $login={roleCookie && target !== 'qr'}>
				<Link to='/'>
					<Style.LogoImg src={logo} />
				</Link>

				{roleCookie && target !== 'qr' && (
					<>
						<Style.ProfileDiv>
							<p>{convertRoleAsName[roleCookie]}</p>
							<h2>{nameCookie}</h2>
						</Style.ProfileDiv>

						<Style.MobileButtonsContainer>
							{roleCookie === ROLE_STORE_MANAGER ||
							roleCookie === ROLE_FRANCHISE_MANAGER ? (
								<Style.MobileMenuButton
									onClick={() => navigate('/qr-scan/store')}
								>
									<img src={scan} alt='scan' />
								</Style.MobileMenuButton>
							) : (
								<Style.MobileMenuButton
									onClick={() => navigate('/qr-scan/tournament')}
								>
									<img src={scan} alt='scan' />
								</Style.MobileMenuButton>
							)}
							<Style.MobileMenuButton onClick={toggleDrawer}>
								<img src={hamberger} alt='hamberger' />
							</Style.MobileMenuButton>
						</Style.MobileButtonsContainer>
					</>
				)}
			</Style.Header>

			{/* Mobile Drawer */}
			{roleCookie && target !== 'qr' && (
				<ModernDrawer
					open={isDrawerOpen}
					onClose={closeDrawer}
					direction='right'
					size={280}
					title='Menu'
					showCloseButton={true}
					overlayOpacity={0.5}
					duration={300}
				>
					<Aside 
						isMobileDrawer={true} 
						onNavigate={closeDrawer} 
						versionData={versionData} 
					/>
				</ModernDrawer>
			)}
		</>
	)
}

export default Header
